module.exports = __webpack_public_path__ + "static/media/DENUNCIA.b4fc4168.jpg";